import { render } from "./upcomingEvents.vue?vue&type=template&id=28e3a6e6"
import script from "./upcomingEvents.vue?vue&type=script&lang=js"
export * from "./upcomingEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__